import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import './MultiPlayerCount.css';
import Button from '../../components/Button/Button';
import { handleHomeClick, playSound } from '../../utils/utils';
import WarpLink from '../../components/WarpTransition/WarpLink';

const MultiPlayerCount = (props) => {
  window.scrollTo(0, 0);

  const { selectPlayerCount } = props;

  const handleNumberOfPlayersClick = (numberOfPlayers) => {
    selectPlayerCount(numberOfPlayers);
    playSound('/sounds/menu-select-4.mp3');
  };

  return (
    <div className="MultiPlayerCount">
      <Link to="/">
        <div className="header">
          <Button
            title="home"
            type="smallSquare home"
            handleClick={handleHomeClick}
          />
        </div>
      </Link>
      <motion.div
        initial={{ scaleY: 0.01 }}
        animate={{ scaleY: 1 }}
        transition={{ duration: 1 }}
      >
        <p className="multiPlayerTitle">number of plAyers</p>
        <div className="multiPlayerNumberButtons">
          <WarpLink
            to="/multi/player-names"
            label="CREW LINK INITIALIZED"
            variant="roll"
          >
            <Button
              title="2"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(2)}
            />
            <Button
              title="3"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(3)}
            />
            <Button
              title="4"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(4)}
            />
            <Button
              title="5"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(5)}
            />
            <Button
              title="6"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(6)}
            />
            <Button
              title="7"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(7)}
            />
            <Button
              title="8"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(8)}
            />
            <Button
              title="9"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(9)}
            />
            <Button
              title="10"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(10)}
            />
            <Button
              title="11"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(11)}
            />
            <Button
              title="12"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(12)}
            />
            <Button
              title="13"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(13)}
            />
            <Button
              title="14"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(14)}
            />
            <Button
              title="15"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(15)}
            />
            <Button
              title="16"
              type="smallSquare playerSelection"
              handleClick={() => handleNumberOfPlayersClick(16)}
            />
          </WarpLink>
        </div>
      </motion.div>
    </div>
  );
};

export default MultiPlayerCount;
